import {signOut} from 'aws-amplify/auth';
import {config} from '../config/amplify/auth';

// FNP-1685: a bare signOut() REJECTS on every deployed stage. Amplify clears the
// tokens first, then refuses the logout redirect because redirectSignOut is the
// portal, a different origin (InvalidOriginException). Naming this stage's
// portal as the preferred redirect makes Amplify send the browser through the
// broker's /logout to the portal; it sets window.location itself and resolves.
// A rejection leaves for '/' at once: redirecting straight after a resolved
// signOut() would override Amplify's navigation. But signOut() also resolves
// WITHOUT navigating when there is no OAuth session (D14b), so a resolved call
// leaves for '/' after a delay. A slow broker /logout may not have unloaded the
// page by then, and assigning location would cancel it, so the timer only acts
// when beforeunload never fired, i.e. nothing is navigating (D14c).
export const signOutToPortal = async () => {
    const redirectUrl = config?.Cognito.loginWith?.oauth?.redirectSignOut[0];
    let leaving = false;
    const onLeave = () => {
        leaving = true;
    };
    window.addEventListener('beforeunload', onLeave);
    try {
        await signOut({global: false, oauth: {redirectUrl}});
        setTimeout(() => {
            if (!leaving) {
                window.location.href = '/';
            }
        }, 3000);
    } catch (error) {
        console.error('Sign out did not complete cleanly', error);
        window.location.href = '/';
    }
};
